import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from '../components';
import { mockForm } from './mocks';
import { ShowcaseHeader } from './ShowcaseHeader';
import { ShowcaseContent } from './ShowcaseContent';
export const ShowcaseView = () => {
    const onSubmit = (data) => {
        console.log(data);
    };
    return (_jsx(Layout, { isForm: true, data: mockForm, onSubmit: onSubmit, breadcrumbs: [
            {
                href: '/',
                title: 'Home'
            },
            {
                href: '#',
                title: 'Development Showcase'
            }
        ], header: _jsx(ShowcaseHeader, {}), content: (formProps) => _jsx(ShowcaseContent, Object.assign({}, formProps)) }));
};
